// Agrupa los kg secos sobrantes (conforme + no conforme) por padre PT
export const agruparSobrantesPorPadrePT = (sobrantes) =>
    sobrantes.reduce((agrupados, item) => {
        const padreId = item.padre_producto_terminado_id;
        if (!padreId) return agrupados;

        const acumulado = agrupados[padreId] || {
            padre_producto_terminado_id: padreId,
            padre_producto_terminado_nombre:
                item.padre_producto_terminado_nombre,
            kg_secos_sobrantes: 0,
        };

        return {
            ...agrupados,
            [padreId]: {
                ...acumulado,
                kg_secos_sobrantes:
                    acumulado.kg_secos_sobrantes +
                    (item.kg_secos_sobrantes_conforme || 0) +
                    (item.kg_secos_sobrantes_no_conforme || 0),
            },
        };
    }, {});

// Combina los totales por padre PT con los kg sobrantes agrupados: suma los
// sobrantes al total producido y agrega, con el resto en cero, los padres PT
// que solo tienen sobrante
export const combinarTotalesPadresConSobrantes = (
    totalesPadresPT,
    sobrantesPorPadrePT,
) => {
    const idsConTotales = totalesPadresPT.map(
        (item) => item.padre_producto_terminado_id,
    );

    const filas = totalesPadresPT.map((item) => {
        const sobrante = sobrantesPorPadrePT[item.padre_producto_terminado_id];
        const kgSobrantes = sobrante ? sobrante.kg_secos_sobrantes : 0;

        return {
            ...item,
            kg_secos_sobrantes: kgSobrantes,
            kg_producidos: (item.kg_producidos || 0) + kgSobrantes,
        };
    });

    const filasSoloSobrante = Object.values(sobrantesPorPadrePT)
        .filter(
            (item) => !idsConTotales.includes(item.padre_producto_terminado_id),
        )
        .map((item) => ({
            ...item,
            cantidad_pacas_paletizadas: 0,
            kg_pacas_paletizadas: 0,
            kg_humedos_tancadas: 0,
            kg_secos_tancadas: 0,
            kg_producidos: item.kg_secos_sobrantes,
        }));

    return [...filas, ...filasSoloSobrante].sort((a, b) =>
        a.padre_producto_terminado_nombre.localeCompare(
            b.padre_producto_terminado_nombre,
        ),
    );
};
